import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SIGNATURE_GROWTH_PSF_WHATSAPP_SHARE_MESSAGE = createFcmDetails(
	'signature_growth_psf_whatsapp_share_message',
	{
		owner: 'Signature Growth',
		context: 'PSF',
		import: false,
		description: `
    Select a different sharing message when sharing via WhatsApp in the PSF.
    `,
		template: {
			isEnabled: false,
			experimentName: '',
			variants: {
				fake_control: { message: '' },
				variant1: { message: '' },
				variant2: { message: '' },
				variant3: { message: '' },
				variant4: { message: '' },
			},
		},
	},
);
